import { createAction } from '@reduxjs/toolkit';

import { EmotionType, ReactionReason, ReactionType } from '../../../../types';

interface ReactionPayload {
    reactionType: ReactionType | null;
    reason?: ReactionReason;
}

export const setReactionAction = createAction<ReactionPayload>('conference/setReaction');
export const setEmotionAction = createAction<EmotionType>('conference/setEmotion');
